<template>
  <a @click="triggerAction">
    <MIcon name="history" class="action-menu-icon" />
    <span class="ml-1 action-menu-text">
      {{ $tc('action') }} {{ $tc('history') }}
    </span>
    <FlotoDrawer :open="showDrawer" width="65%" @hide="hideDrawer">
      <template v-slot:title>
        {{ $tc('action') }} {{ $tc('history') }}: {{ asset.name }}
      </template>
      <FlotoCrudContainer
        as-table
        prepend-new-item
        :columns="tableColumns"
        :fetch-fn="getActionHistory"
      >
        <template v-slot:actionType="{ item }">
          <td class="text-ellipsis">
            {{ $tc(item.actionType) }}
          </td>
        </template>
        <template v-slot:createdBy="{ item }">
          <td class="text-ellipsis">
            <FlotoUserDrawer :user-id="item.createdBy" disabled />
          </td>
        </template>
        <template v-slot:createdAt="{ item }">
          <td class="text-ellipsis">
            <span v-if="item.createdAt">{{ item.createdAt | datetime }}</span>
            <span v-else>---</span>
          </td>
        </template>
        <template v-slot:currentStatus="{ item }">
          <td class="text-ellipsis">
            <CommandStatePicker
              :value="item.currentStatus"
              :as-input="false"
              disabled
              :placeholder="'---'"
            />
          </td>
        </template>
        <template v-slot:updatedAt="{ item }">
          <td class="text-ellipsis">
            <span v-if="item.updatedAt">{{ item.updatedAt | datetime }}</span>
            <span v-else>---</span>
          </td>
        </template>
        <template v-slot:result="{ item }">
          <td class="text-ellipsis">
            {{ item.result || '---' }}
          </td>
        </template>
      </FlotoCrudContainer>
      <template v-slot:actions="{ hide }">
        <MButton variant="default" @click="hide">
          {{ $t('done') }}
        </MButton>
      </template>
    </FlotoDrawer>
  </a>
</template>
<script>
import { searchAssetSystemActionApi } from '@modules/asset/asset-api'
import CommandStatePicker from '@components/data-picker/command-state-picker'
export default {
  name: 'LocationHistoryDrawer',
  components: { CommandStatePicker },
  props: {
    asset: { type: Object, required: true },
  },
  data() {
    // this.actionTypeOptions = () => [
    //   { text: this.$tc('lock'), key: 'lock' },
    //   { text: this.$tc('restart'), key: 'restart' },
    //   { text: this.$tc('shutdown'), key: 'shutdown' },
    //   { text: this.$tc('sleep'), key: 'sleep' },
    // ]
    return {
      showDrawer: false,
      tableColumns: [
        {
          name: `${this.$tc('action_type')}`,
          key: 'actionType',
        },
        { name: `${this.$tc('initiated_by')}`, key: 'createdBy' },
        {
          name: `${this.$tc('initiated_time')}`,
          key: 'createdAt',
        },
        {
          name: `${this.$tc('current_status')}`,
          key: 'currentStatus',
        },
        {
          name: `${this.$tc('last_updated_time')}`,
          key: 'updatedAt',
        },
        {
          name: `${this.$tc('remark')}`,
          key: 'result',
        },
      ],
    }
  },
  methods: {
    triggerAction() {
      this.$emit('trigger')
      // show modal after dropdown is hide
      setTimeout(() => {
        this.showDrawer = true
      }, 400)
    },
    hideDrawer() {
      this.showDrawer = false
    },
    getActionHistory(limit, offset) {
      return searchAssetSystemActionApi(this.asset.id, limit, offset)
    },
  },
}
</script>
